import { CLICK_ACTIONS } from "../../../utils/Constant";
import { ColumnHeaderType } from "../../../utils/Types";
import { amountValueGetter, blankValueGetter, dateValueGetter, healthKycStatusClassGetter, healthKycStatusValueGetter, healthPaymentStatusClassGetter, healthPaymentStatusValueGetter, healthPolicyStatusClassGetter, healthPolicyStatusValueGetter, capitalizeFirstLetterValueGetter, healthProposalStatusClassGetter, policyStardateValueGetter } from "../../../utils/Util";

export const HEALTH_APPLICATION_HEADERS: ColumnHeaderType[] = [
    {
        name: "CID Number",
        field: "cid",
        clickable: true,
        action: CLICK_ACTIONS.SELECT_HEALTH_APPLICATION,
        valueGetter: blankValueGetter
    },
    {
        name: "Policy Id",
        field: "policyNo",
        valueGetter: blankValueGetter
    },
    {
        name: "KYC Status",
        field: "ckycStatus",
        valueGetter: healthKycStatusValueGetter,
        classNameGetter: healthKycStatusClassGetter
    },
    {
        name: "Proposal Status",
        field: "proposalStatus",
        valueGetter: blankValueGetter,
        classNameGetter: healthProposalStatusClassGetter
    },
    {
        name: "Policy Status",
        field: "policyStatus",
        valueGetter: healthPolicyStatusValueGetter,
        classNameGetter: healthPolicyStatusClassGetter
    },
    {
        name: "Policy Type",
        field: "policyType",
        valueGetter: capitalizeFirstLetterValueGetter
    }
];

export const HEALTH_MEMBER_DETAILS_HEADERS: ColumnHeaderType[] = [
    {
      name: 'Member Name',
      field: 'customerName',
      sortable: false,
      valueGetter: blankValueGetter,
      action: CLICK_ACTIONS.SELECT_HEALTH_MEMBER,
      clickable: true,
    },
    {
      name: 'Member ID',
      field: 'memberId',
      sortable: false,
      valueGetter: blankValueGetter,
      clickable: false,
    },
    {
      name: 'Mobile Number',
      field: 'mobileNumber',
      sortable: false,
      valueGetter: blankValueGetter,
      clickable: false,
    },
    {
      name: 'Pin Code',
      field: 'pincode',
      sortable: false,
      valueGetter: blankValueGetter,
      clickable: false,
    },
    {
      name: 'City',
      field: 'city',
      sortable: false,
      valueGetter: blankValueGetter,
      clickable: false,
    },
    {
      name: 'State',
      field: 'state',
      sortable: false,
      valueGetter: blankValueGetter,
      clickable: false,
    },
];

export const HEALTH_PROPOSAL_DETAILS_HEADERS: ColumnHeaderType[] = [
    {
      name: 'CID Number',
      field: 'cid',
      sortable: false,
      valueGetter: blankValueGetter,
      action: CLICK_ACTIONS.SELECT_PROPOSAL,
      clickable: true,
    },
    {
      name: 'Member ID',
      field: 'memberId',
      sortable: false,
      valueGetter: blankValueGetter,
      clickable: false,
    },
    {
      name: 'Proposer Name',
      field: 'proposalName',
      sortable: false,
      valueGetter: blankValueGetter,
      clickable: false,
    },
    {
      name: 'Proposal Issue Date',
      field: 'proposalIssueDate',
      sortable: false,
      valueGetter: dateValueGetter,
      clickable: false,
    },
    {
      name: 'Payment Status',
      field: 'paymentStatus',
      sortable: false,
      valueGetter: healthPaymentStatusValueGetter,
      classNameGetter: healthPaymentStatusClassGetter,
      clickable: false,
    },
    {
      name: 'Product',
      field: 'product',
      sortable: false,
      valueGetter: blankValueGetter,
      clickable: false,
    },
    {
      name: 'Policy Type',
      field: 'policyType',
      sortable: false,
      valueGetter: capitalizeFirstLetterValueGetter,
      clickable: false,
    }
];

export const HEALTH_CLAIM_DETAILS_HEADERS: ColumnHeaderType[] = [
    {
      name: 'Member ID',
      field: 'memberId',
      sortable: false,
      valueGetter: blankValueGetter,
      clickable: false,
    },
    {
      name: 'Policy Number',
      field: 'policyNumber',
      sortable: false,
      valueGetter: blankValueGetter,
      clickable: false,
    },
    {
      name: 'Claim Number',
      field: 'claimNumber',
      sortable: false,
      valueGetter: blankValueGetter,
      action: CLICK_ACTIONS.SELECT_CLAIM,
      clickable: true,
    },
    {
      name: 'Claim Status',
      field: 'claimStatus',
      sortable: false,
      valueGetter: blankValueGetter,
      clickable: false,
    },
    {
      name: 'Claim Sub Status',
      field: 'claimSubStatus',
      sortable: false,
      valueGetter: blankValueGetter,
      clickable: false,
    },
    {
      name: 'Reason For Claim Status',
      field: 'claimRemarks',
      sortable: false,
      valueGetter: blankValueGetter,
      clickable: false,
    },
    {
      name: 'Claim Intimation Date',
      field: 'claimIntimationDate',
      sortable: false,
      valueGetter: dateValueGetter,
      clickable: false,
    },
    {
      name: 'Claim Settlement Date',
      field: 'claimSettlementDate',
      sortable: false,
      valueGetter: dateValueGetter,
      clickable: false,
    },
    {
      name: 'Settlement Amount',
      field: 'claimSettlementAmount',
      sortable: false,
      valueGetter: amountValueGetter,
      clickable: false,
    },
    {
      name: 'Product',
      field: 'product',
      sortable: false,
      valueGetter: blankValueGetter,
      clickable: false,
    },
    {
      name: 'Policy Type',
      field: 'policyType',
      sortable: false,
      valueGetter: capitalizeFirstLetterValueGetter,
      clickable: false,
    }
];

export const HEALTH_POLICY_DETAILS_HEADERS: ColumnHeaderType[] = [
    {
      name: 'CID Number',
      field: 'cid',
      sortable: false,
      valueGetter: blankValueGetter,
      clickable: false,
    },
    {
      name: 'Member ID',
      field: 'memberId',
      sortable: false,
      valueGetter: blankValueGetter,
      clickable: false,
    },
    {
      name: 'Policy Number',
      field: 'policyNumber',
      sortable: false,
      valueGetter: blankValueGetter,
      action: CLICK_ACTIONS.SELECT_POLICY,
      clickable: true,
    },
    {
      name: 'Policy Holder Name',
      field: 'policyHolderName',
      sortable: false,
      valueGetter: blankValueGetter,
      clickable: false,
    },
    {
      name: 'Policy Start Date',
      field: 'policyStartDate',
      sortable: false,
      valueGetter: policyStardateValueGetter,
      clickable: false,
    },
    {
      name: 'Policy End Date',
      field: 'policyEndDate',
      sortable: false,
      valueGetter: dateValueGetter,
      clickable: false,
    },
    {
      name: 'Premium',
      field: 'premium',
      sortable: false,
      valueGetter: amountValueGetter,
      clickable: false,
    },
    {
      name: 'Product',
      field: 'product',
      sortable: false,
      valueGetter: blankValueGetter,
      clickable: false,
    },
    {
      name: 'Policy Type',
      field: 'policyType',
      sortable: false,
      valueGetter: capitalizeFirstLetterValueGetter,
      clickable: false,
    },
    {
      name: 'Policy Tenure',
      field: 'policyTenure',
      sortable: false,
      valueGetter: capitalizeFirstLetterValueGetter,
      clickable: false,
    }
];
